import { render, staticRenderFns } from "./fabujicai.vue?vue&type=template&id=4fdc7437&scoped=true&"
import script from "./fabujicai.vue?vue&type=script&lang=js&"
export * from "./fabujicai.vue?vue&type=script&lang=js&"
import style0 from "./fabujicai.vue?vue&type=style&index=0&id=4fdc7437&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc7437",
  null
  
)

export default component.exports